<div class="profileCard">
  <span (click)="hideProfile()" class="profileCard__close"></span>
  <vc-ref
    class="profileCard__wrap"
    i18n-resource="@@PRODUCT.DETAILS.SELLER_PROFILE_LINK"
    [resource]="'/membres/profil-' + profile.describes.url + '.shtml'"
    (click)="onClickSeeProfile({emitter: 'link', profileId: profile.describes.id, trackingKey: profile.trackingKey})"
  >
    <ul class="profileCard__info">
      <li class="profileCard__info__pic">
        <img [src]="avatarSrc" alt="" />
      </li>
      <li class="profileCard__info__name vc-text-s">{{ profile.describes.name }}</li>
      <li *ngIf="profile.describes.sellerBadge === 'expert'" class="profileCard__info__status vc-badge--expert">
        <vc-sprite-icons
          class="profileCard__info__status__icon profileCard__info__status__icon--expert"
          name="badge-expert"
        ></vc-sprite-icons>
        <span i18n="@@FEED.SUGGESTION_PROFILE.STATUS_EXPERT">Expert seller</span>
      </li>
      <li *ngIf="profile.describes.sellerBadge === 'trusted'" class="profileCard__info__status vc-badge--trusted">
        <vc-sprite-icons
          class="profileCard__info__status__icon profileCard__info__status__icon--trusted"
          name="badge-trusted"
        ></vc-sprite-icons>
        <span i18n="@@FEED.SUGGESTION_PROFILE.STATUS_TRUSTED">Trusted seller</span>
      </li>
      <li class="profileCard__info__loc vc-text-xs">
        <vc-sprite-icons class="profileCard__info__loc__icon" name="pin-full"></vc-sprite-icons>
        <span class="profileCard__info__loc__city">{{ profile.describes.location }}</span>
      </li>
      <li class="profileCard__info__foll vc-text-xs" i18n="@@FEED.SUGGESTION_PROFILE.FOLLOWERS">
        {{ profile.describes.followers }} followers
      </li>
    </ul>
  </vc-ref>
  <vc-follow-button
    *ngIf="!profile.isFollowed"
    class="profileCard__cta vc-btn vc-btn--social vc-btn--small vc-btn--full"
    i18n="@@FEED.SUGGESTION_PROFILE.CTA"
    [userToFollow]="profile.describes.id"
    [isFollow]="profile.isFollowed"
    [stopPropagation]="false"
    (click)="onClickFollow(profile.describes.id)"
    >FOLLOW</vc-follow-button
  >
  <vc-ref
    *ngIf="profile.isFollowed"
    i18n="@@FEED.CARD.PROFILE.FOLLOWING"
    [anchor]="false"
    [resource]="'/membres/profil-' + profile.describes.url + '.shtml'"
    class="profileCard__cta vc-text-xs vc-btn vc-btn--secondary vc-btn--small vc-btn--full"
    (click)="onClickSeeProfile({emitter: 'button', profileId: profile.describes.id, trackingKey: profile.trackingKey})"
    >Following</vc-ref
  >
</div>
